import { Controller } from 'react-hook-form';
import { Input } from '@mantine/core';

export function FormInput({ name, control, label, required = false, disabled = false, ...props }) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value } }) => (
        <Input.Wrapper required={required} label={label} description={props.description}>
          <Input
            {...props}
            disabled={disabled}
            required={required}
            onChange={onChange}
            value={value}
          />
        </Input.Wrapper>
      )}
    />
  );
}
